import { APP_ID, inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthNavigationService {
  readonly #router = inject(Router);
  readonly #app_id = inject(APP_ID);
  readonly #returnUrl = signal<string | null>(null);

  setReturnUrl(url: string | null) {
    this.#returnUrl.set(url);
  }

  getCurrentReturnUrl(): string | null {
    return this.#returnUrl();
  }

  navigateToLogin() {
    const currentUrl = this.#router.routerState.snapshot.url;
    this.setReturnUrl(currentUrl);
    this.#router.navigateByUrl('/auth/login');
  }

  navigateAfterLogout() {
    this.#router.navigateByUrl('/events');
  }

  navigateAfterLogin() {
    if (
      this.#app_id === 'control-hub' ||
      this.#app_id === 'control-hub-desktop'
    ) {
      this.#router.navigateByUrl('/');
    } else {
      return;
    }
  }
}
